import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7487384c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textbox__entry textbox__icon searchbox__entry" }
const _hoisted_2 = ["disabled", "placeholder"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-1 button-icon-align" }
const _hoisted_9 = {
  key: 0,
  class: "col-1 button-text-with-icon"
}
const _hoisted_10 = {
  key: 1,
  class: "col-1 button-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: _normalizeClass(["textbox", _ctx.hideLabel ? 'sr-only' : null])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.labelClass)
      }, _toDisplayString(_ctx.label), 3)
    ], 2),
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass('icon-' + _ctx.icon),
        style: {"font-size":"36px"}
      }, null, 2),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localInputValue) = $event)),
        class: "textbox__input",
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        type: "text",
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
        onKeyup: [
          _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
          _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["esc"]))
        ],
        style: {"font-size":"12px"}
      }, null, 40, _hoisted_2), [
        [_vModelText, _ctx.localInputValue]
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["searchbox__reset", [!_ctx.localInputValue ? 'searchbox__reset--hidden' : undefined]]),
        "data-test": "button-searchReset",
        disabled: _ctx.disabled,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
      }, _hoisted_5, 10, _hoisted_3),
      _createElementVNode("button", {
        class: "searchbox__search",
        "data-test": "button-search",
        disabled: _ctx.disabled || !_ctx.localInputValue || _ctx.buttonDisabled,
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", {
              class: _normalizeClass(['icon-' + _ctx.buttonIcon, "button-icon"])
            }, null, 2)
          ]),
          (_ctx.buttonIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.buttonText), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.buttonText), 1))
        ])
      ], 8, _hoisted_6)
    ])
  ]))
}